var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-box-container",
      attrs: { id: _vm.company.id },
      on: {
        mouseup: function($event) {
          _vm.$_can("companies.show")
        }
      }
    },
    [
      [
        _c(
          "div",
          {
            staticClass: "d-flex list-box-header col-12 pointer",
            on: {
              mouseup: function($event) {
                if ("button" in $event && $event.button !== 1) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                _vm.viewMiddle($event, _vm.company.id)
              },
              click: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "left", 37, $event.key, [
                    "Left",
                    "ArrowLeft"
                  ])
                ) {
                  return null
                }
                if ("button" in $event && $event.button !== 0) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                _vm.view($event, _vm.company.id)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "pl-0 list-box-header-left col-lg-7 col-7 col-md-6 pr-3"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "pl-0 d-flex align-items-center col-5 col-md-6"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "list-box-status align-items-start col-12"
                      },
                      [
                        _c("span", { staticClass: "ref-id" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.company.name) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pl-0 d-flex align-items-center col-7" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "list-box-status align-items-start col-12"
                      },
                      [
                        _vm.company.status.name === "Active"
                          ? _c("span", { class: "btn-status btn-active" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Inactive"
                          ? _c("span", { class: "btn-status btn-pending" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.company.status.name === "Setup Incomplete"
                          ? _c("span", { class: "btn-status btn-rejected" }, [
                              _vm._v(_vm._s(_vm.company.status.name))
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-box-header-right col-lg-5 col-5 pl-4" },
              [
                _c("div", { staticClass: "d-flex align-items-center col-12" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.company.rating ? _vm.company.rating : "No reviews"
                      ) +
                      "\n        "
                  )
                ])
              ]
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69080d30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69080d30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ratings/RatingsBlock.vue
// module id = null
// module chunks = 